import { render, staticRenderFns } from "./collectionSignedReportDetails.vue?vue&type=template&id=b19c85e0"
import script from "./collectionSignedReportDetails.vue?vue&type=script&lang=js"
export * from "./collectionSignedReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b19c85e0')) {
      api.createRecord('b19c85e0', component.options)
    } else {
      api.reload('b19c85e0', component.options)
    }
    module.hot.accept("./collectionSignedReportDetails.vue?vue&type=template&id=b19c85e0", function () {
      api.rerender('b19c85e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/bulletinBoard/receivablesStatistics/collectionSignedReportDetails.vue"
export default component.exports